import { useTranslation } from "react-i18next";
import { HELPLINES } from "../../lib/helplines";

const SupportScreen = ({ locale }: { locale: "en" | "he" | "de" }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <h2 className="text-2xl font-serif">{t("startFlow.support.title")}</h2>
      <p className="text-lg leading-relaxed">{t("startFlow.support.body")}</p>
      <p className="font-semibold">{t("startFlow.support.emergency")}</p>
      <h3 className="pt-2 text-sm uppercase tracking-wider text-[#5b6b61]">{t("startFlow.support.lines")}</h3>
      <ul className="space-y-2">
        {HELPLINES[locale].map((h) => (
          <li key={h.name + h.phone} className="rounded-xl bg-white p-3">
            <span className="font-medium">{h.name}</span>
            {h.phone && <a className="ms-2 underline" href={`tel:${h.phone.replace(/\s/g, "")}`}>{h.phone}</a>}
            {h.url && <a className="ms-2 underline" href={h.url} target="_blank" rel="noreferrer">{new URL(h.url).hostname}</a>}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SupportScreen;
